<template>
  <div class="modal-container choose-match-invoice">
    <!-- {{orderType}} -->
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li v-if="!isTax">
            <vxe-radio name="xtabs" label="tab1">订单2.0</vxe-radio>
          </li>
          <li v-else>
            <vxe-radio name="xtabs" label="tab2">撮合订单</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="my-search" v-show="selectTab === 'tab1'">
        <vxe-input
          v-model="searchOrdersNum"
          style="width: 150px"
          type="search"
          placeholder="输入订单编号"
          @search-click="search"
          @keyup.enter.native="search"
        ></vxe-input>
        <vxe-input
          v-model="searchOrdersName"
          type="search"
          placeholder="输入订单标题"
          @search-click="search"
          @keyup.enter.native="search"
          style="width: 150px; margin-left: 10px"
        ></vxe-input>
        <Select
          v-model="searchOrdersBuyer"
          filterable
          :remote-method="(file) => remoteMethod(file,'buyerNameOptions','twoOrders', 'searchCondition',3)"
          :clearable="true"
          :loading="searchLoading"
          placeholder="输入托运人名称"
          @keyup.enter.native="search"
          style="width: 150px; margin-left: 10px"
        >
          <Option v-for="option in buyerNameOptions" :value="option.id" :key="option.id"
            >{{ option.name }}
          </Option>
        </Select>
        <Select
          v-model="searchPlatformCompany"
          filterable
          :clearable="true"
          :loading="searchLoading"
          :remote-method="(file) => remoteMethod(file,'PlatIdListOption','twoOrders', 'searchCondition',1)"
          placeholder="输入平台企业"
          @keyup.enter.native="search"
          style="width: 150px; margin-left: 10px"
        >
          <Option v-for="option in PlatIdListOption" :value="option.id" :key="option.id"
            >{{ option.name }}
          </Option>
        </Select>
        <Select
          v-model="searchOrdersSeller"
          filterable
          :clearable="true"
          :loading="searchLoading"
          :remote-method="(file) => remoteMethod(file,'sellerNameOptions','twoOrders', 'searchCondition',4)"
          placeholder="输入承运人名称"
          @search-click="search"
          @keyup.enter.native="search"
          style="width: 150px; margin-left: 10px"
        >
          <Option v-for="option in sellerNameOptions" :value="option.id" :key="option.id"
            >{{ option.name }}
          </Option>
        </Select>
        <vxe-input
          v-model="searchOrdersCarShipNum"
          type="search"
          placeholder="输入车船号"
          @search-click="search"
          @keyup.enter.native="search"
          style="width: 150px; margin-left: 10px"
        ></vxe-input>
        <Select
          v-model="searchOrdersSaleMan"
          filterable
          :clearable="true"
          :loading="searchLoading"
          :remote-method="(file) => remoteMethod(file,'saleManOptions','twoOrders', 'searchCondition',5)"
          placeholder="输入业务员"
          @search-click="search"
          @keyup.enter.native="search"
          style="width: 150px; margin-left: 10px"
        >
          <Option v-for="option in saleManOptions" :value="option.id" :key="option.id"
            >{{ option.name }}
          </Option>
        </Select>
        <Button
          icon="ios-search"
          type="primary"
          @click="search"
          style="width: 100px; margin-left: 10px"
          >搜索</Button
        >
      </div>
      <div class="my-search" v-show="selectTab === 'tab2'">
        <vxe-input
          v-model="searchOrdersNum2"
          style="width: 150px"
          type="search"
          placeholder="输入订单编号"
          @search-click="search2"
          @keyup.enter.native="search2"
        ></vxe-input>
        <Select
          v-model="searchOrdersBuyer2"
          filterable
          :clearable="true"
          :loading="searchLoading"
          :remote-method="(file) => remoteMethod(file,'buyerNameOptions2','matchOrder', 'searchCondition',3)"
          placeholder="输入托运人名称"
          @keyup.enter.native="search2"
          style="width: 150px; margin-left: 10px"
        >
          <Option v-for="option in buyerNameOptions2" :value="option.id" :key="option.id"
            >{{ option.name }}
          </Option>
        </Select>
        <Select
          v-model="searchOrdersSeller2"
          filterable
          :clearable="true"
          :loading="searchLoading"
          :remote-method="(file) => remoteMethod(file,'sellerNameOptions2','matchOrder', 'searchCondition',4)"
          placeholder="输入承运人名称"
          @search-click="search2"
          @keyup.enter.native="search2"
          style="width: 150px; margin-left: 10px"
        >
          <Option v-for="option in sellerNameOptions2" :value="option.id" :key="option.id"
            >{{ option.name }}
          </Option>
        </Select>
        <vxe-input
          v-model="searchOrdersCarShipNum2"
          type="search"
          placeholder="输入车船号"
          @search-click="search2"
          @keyup.enter.native="search2"
          style="width: 150px; margin-left: 10px"
        ></vxe-input>
        <Button
          icon="ios-search"
          type="primary"
          @click="search2"
          style="width: 100px; margin-left: 10px"
          >搜索</Button
        >
      </div>
      <div v-show="selectTab === 'tab1'">
        <div class="add-box clearfix">
          <vxe-table
            ref="xTable1"
            class="table-style"
            max-height="430"
            border="none"
            align="center"
            :data="tableData"
            :loading="loading"
            auto-resize
            :radio-config="{ highlight: true }"
            show-overflow
            highlight-hover-row
            @cell-click="cellClickEvent"
          >
            <vxe-table-column field="ordersNum" title="订单编号" width="130"> </vxe-table-column>
            <vxe-table-column field="ordersTitle" title="订单标题" width="150"></vxe-table-column>
            <vxe-table-column
              field="buyerName"
              title="托运人名称"
              show-overflow
              width="200"
            ></vxe-table-column>
            <vxe-table-column
              field="compName"
              title="平台企业"
              show-overflow
              width="200"
            ></vxe-table-column>
            <vxe-table-column
              field="sellerName"
              title="承运人名称"
              show-overflow
              width="200"
            ></vxe-table-column>
            <vxe-table-column field="goodsName" title="货名" width="105"></vxe-table-column>
            <!--        <vxe-table-column field="rule" title="规格" width="100"></vxe-table-column>-->
            <vxe-table-column field="goodsUnit" title="单位" width="100"></vxe-table-column>
            <vxe-table-column field="realCount" title="数量" width="100"> </vxe-table-column>
            <vxe-table-column field="carShipNum" title="车船号" width="100"></vxe-table-column>
            <vxe-table-column field="beginPlace" title="起运地" width="100"></vxe-table-column>
            <vxe-table-column field="endPlace" title="到达地" width="100"></vxe-table-column>
            <vxe-table-column field="beginTime" title="起运日期" width="140">
              <template slot-scope="{ row }">
                <span>{{ row.beginTime | timePartRule }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="createUser" title="创建人" width="100"></vxe-table-column>
            <vxe-table-column field="createTime" title="创建日期" width="120">
              <template slot-scope="{ row }">
                <span>{{ row.createTime | timePartRule }}</span>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <vxe-pager
          background
          size="small"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          :total="totalResult"
          @page-change="changePage1"
        ></vxe-pager>
      </div>
      <div v-show="selectTab === 'tab2'">
        <div class="add-box clearfix">
          <vxe-table
            ref="xTable1"
            class="table-style"
            max-height="430"
            border="none"
            align="center"
            :data="tableData2"
            :loading="loading"
            auto-resize
            :radio-config="{ highlight: true }"
            show-overflow
            highlight-hover-row
            @cell-click="cellClickEvent"
          >
            <vxe-table-column field="ordersNum" title="订单编号" width="130"> </vxe-table-column>
            <vxe-table-column
              field="buyerName"
              title="托运人名称"
              show-overflow
              width="200"
            ></vxe-table-column>
            <vxe-table-column
              field="sellerName"
              title="承运人名称"
              show-overflow
              width="200"
            ></vxe-table-column>
            <vxe-table-column field="goodsName" title="货名" width="105"></vxe-table-column>
            <vxe-table-column field="goodsUnit" title="单位" width="100"></vxe-table-column>
            <vxe-table-column field="realCount" title="数量" width="100"> </vxe-table-column>
            <vxe-table-column field="carShipNum" title="车船号" width="100"></vxe-table-column>
            <vxe-table-column field="beginPlace" title="起运地" width="100"></vxe-table-column>
            <vxe-table-column field="endPlace" title="到达地" width="100"></vxe-table-column>
            <vxe-table-column field="beginTime" title="起运日期" width="140">
              <template slot-scope="{ row }">
                <span>{{ row.beginTime | timePartRule }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="createUser" title="创建人" width="100"></vxe-table-column>
            <vxe-table-column field="createTime" title="创建日期" width="120">
              <template slot-scope="{ row }">
                <span>{{ row.createTime | timePartRule }}</span>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <vxe-pager
          background
          size="small"
          :current-page.sync="currentPage2"
          :page-size.sync="pageSize"
          :total="totalResult2"
          @page-change="changePage2"
        ></vxe-pager>
      </div>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { isEmpty } from "@/utils/util";

export default {
  name: "ChooseOrderTwo",
  props: {
    chainId: {
      type: [String, Number],
      default: 0,
    },
    orderCate: {
      type: String,
      default: "",
    },
    isTax: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableData3: [],
      filterName: null,
      orderName: null,
      tableData: [],
      loading: false,
      selectRow: null,
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
      selectTab: "tab1",
      listQuery: {
        page: 1,
        rows: 10,
        orderBy: 2,
      },
      orderType: 1,
      searchPlatformCompany: "", //所属平台
      searchOrdersNum: "", //搜索订单号
      searchOrdersName: "", //搜索托运人 或 承运人 实际承运人 名称
      searchOrdersBuyer: "",
      searchOrdersCompName: "",
      searchOrdersSeller: "",
      searchOrdersCarShipNum: "",
      searchOrdersSaleMan: "",
      buyerNameOptions: [], // 搜索托运人下拉框
      sellerNameOptions: [],
      PlatIdListOption: [],
      saleManOptions: [],
      searchLoading: false,
      searchOrdersNum2: "",
      searchOrdersBuyer2: "",
      searchOrdersSeller2: "",
      searchOrdersCarShipNum2: "",
      buyerNameOptions2: [], // 搜索托运人下拉框
      sellerNameOptions2: [],
      listQuery2: {
        page: 1,
        rows: 10,
        orderBy: 2,
      },
      currentPage2: 1,
      totalResult2: 0,
      tableData2: [],
    };
  },
  watch: {
    selectTab(val, oldVal) {
      if (oldVal) {
        val === "tab1" ? this.getOrderList() : this.getMatchOrderList();
      }
    },
  },
  //获取列表
  filters: {
    // 时间显示part（年月日）
    timePartRule: function (t) {
      if (t) {
        var timeB = new Date(t);
        var y = 1900 + timeB.getYear();
        var m = "0" + (timeB.getMonth() + 1);
        var d = "0" + timeB.getDate();

        return (
          y + "-" + m.substring(m.length - 2, m.length) + "-" + d.substring(d.length - 2, d.length)
        );
      } else {
        return "";
      }
    },
  },
  created() {
    // this.getSelData();
  },
  methods: {
    init(cate) {
      this.selectTab = this.isTax ? 'tab2' : "tab1";
      this.searchPlatformCompany = ""; //所属平台
      this.searchOrdersNum = ""; //搜索订单号
      this.searchOrdersName = ""; //搜索托运人 或 承运人 实际承运人 名称
      this.searchOrdersBuyer = "";
      this.searchOrdersCompName = "";
      this.searchOrdersSeller = "";
      this.searchOrdersCarShipNum = "";
      this.searchOrdersSaleMan = "";
      this.searchOrdersNum2 = "";
      this.searchOrdersBuyer2 = "";
      this.searchOrdersSeller2 = "";
      this.searchOrdersCarShipNum2 = "";
      this.currentPage = 1;
      this.listQuery = {
        page: 1,
        rows: 10,
        buyerIdList: [],
        sellerIdList: [],
        saleManIdList: [],
        platformCompanyIdList: [],
      };
      this.listQuery2 = {
        page: 1,
        rows: 10,
        buyerIdList: [],
        sellerIdList: [],
      };
      this.getOrderList();
      this.getMatchOrderList();
    },
    cancel() {},
    search() {
      this.currentPage = 1;
      this.listQuery = {
        page: 1,
        rows: 10,
        buyerIdList: [],
        sellerIdList: [],
        saleManIdList: [],
        platformCompanyIdList: [],
      };
      this.getOrderList();
    },
    search2() {
      this.currentPage2 = 1;
      this.listQuery2 = {
        page: 1,
        rows: 10,
        buyerIdList: [],
        sellerIdList: [],
      };
      this.getMatchOrderList();
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        cate: columnType,
        name: query,
      };
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        this[options] = res.data;
      }
    },
    changePage2(val) {
      this.listQuery2.page = val.currentPage;
      this.getMatchOrderList();
    },
    async getMatchOrderList() {
      this.loading = true;
      if (this.searchOrdersNum2) {
        this.listQuery2.ordersNum = this.searchOrdersNum2;
      }
      if (this.searchOrdersCarShipNum2) {
        this.listQuery2.carShipNum = this.searchOrdersCarShipNum2;
      }
      if (this.searchOrdersBuyer2) {
        this.listQuery2.buyerIdList.push(this.searchOrdersBuyer2);
      }
      if (this.searchOrdersSeller2) {
        this.listQuery2.sellerIdList.push(this.searchOrdersSeller2);
      }
      let res = await $api.matchOrder.post("selectList", this.listQuery2);

      if (res.status == 1) {
        this.tableData2 = res.data.rows;
        this.totalResult2 = res.data.total;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },
    async getOrderList() {
      this.loading = true;
      if (this.searchOrdersNum) {
        this.listQuery.ordersNum = this.searchOrdersNum;
      }
      if (this.searchOrdersName) {
        this.listQuery.ordersTitle = this.searchOrdersName;
      }
      if (this.searchOrdersBuyer) {
        this.listQuery.buyerIdList.push(this.searchOrdersBuyer);
      }
      if (this.searchOrdersSeller) {
        this.listQuery.sellerIdList.push(this.searchOrdersSeller);
      }
      if (this.searchOrdersCarShipNum) {
        this.listQuery.carShipNum = this.searchOrdersCarShipNum;
      }
      if (this.searchOrdersSaleMan) {
        this.listQuery.saleManIdList.push(this.searchOrdersSaleMan);
      }
      if (this.searchPlatformCompany) {
        this.listQuery.platformCompanyIdList.push(this.searchPlatformCompany);
      }
      let res = await $api.twoOrders.post("selectList", this.listQuery);

      if (res.status == 1) {
        this.tableData = res.data.rows;
        // console.log(this.tableData);
        // debugger
        this.totalResult = res.data.total;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },

    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    changePage1(val) {
      this.listQuery.page = val.currentPage;
      this.getOrderList();
      //   console.log(`当前页: ${val}`);
    },
    radioChangeEvent({ row }) {
      this.selectRow = row;
      console.log(this.selectRow);
    },
    commit() {
      //   this.$emit("chooseOrder", this.$refs.xTable1.getRadioRecord());
    },
    clickEvent3(id) {
      this.$refs[id].togglePanel();
    },
    cellClickEvent({ row }) {
      let obj = { orderType: this.orderType };
      obj.isMatchOrder = this.selectTab === "tab2" ? true : false;
      obj.ordersVersion = this.selectTab === "tab2" ? 3 : 2;
      this.selectRow = Object.assign(row, obj);
      //   console.log(this.selectRow);
      this.$emit("chooseOrder", this.selectRow);
      //   console.log("单元格点击事件");
    },
  },
};
</script>

<style scoped>
.add-box .vxe-input {
  height: 30px;
  border: 1px solid #f8f8f8;
}

.modal-container {
  position: relative;
  height: 100%;
}

.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.my-search {
  padding: 10px;
  position: absolute;
  right: 0;
  top: -3px;
}
.my-search >>> .ivu-select-selection {
  height: 34px;
  border-radius: 0;
}

.my-search >>> .ivu-icon-ios-arrow-down {
  position: absolute;
  right: 5px;
  color: #999;
  cursor: pointer;
}
.my-search .vxe-input {
  height: 34px;
  width: 400px;
  vertical-align: middle;
}

.my-search .vxe-input >>> .vxe-input--suffix {
  display: block !important;
  width: 60px;
  height: 32px;
  top: 1px;
  text-align: center;
  border-left: 1px solid #dcdfe6;
  background-color: #f5f7fa;
  cursor: pointer;
}

.my-search .vxe-input >>> .vxe-input--inner {
  border: 1px solid #dcdfe6;
}
/* .xxx .sel-modal-header {
    width: 100%;
    height: 44px;
    margin-bottom: 0px;
  } */
.choose-match-invoice .vxe-radio-group,
.choose-match-invoice .tab-list {
  width: 100%;
  box-sizing: border-box;
}
.choose-match-invoice .tab-list {
  border-bottom: 1px solid #dcdee2;
}
.choose-match-invoice .tab-list li {
  padding: 0 20px;
  margin-right: 0px;
}
.choose-match-invoice .my-search {
  margin-top: 10px;
  position: relative;
}
</style>
